import { FC, useContext, useEffect } from "react";
import { CreateOrderAPIResponse, CreateOrderModalProps, CreateOrderProps } from "./types";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CreateOrderSchema } from "src/validation/createOrder";
import HubInputField from "src/components/inputType";
import { GroupBase, OptionsOrGroups } from "react-select";


const CreateOrderModal: FC<CreateOrderModalProps> = ({ isModalVisible, hideModal, orderType ,refreshListing}): JSX.Element => {
  const { control, handleSubmit, reset  } = useForm<CreateOrderProps>({
    mode: 'all',
    resolver: yupResolver(CreateOrderSchema),
  });
  const { showToast } = useContext(ToastContext);
  const { hideLoader } = useContext(LoaderContext);
  const { data: creatOrderResponseData, mutate: createOrder, error: createOrderError } =
    useFetch<CreateOrderAPIResponse>(APIEndpoints.CREATE_ORDER);
  const clickOnCreateOrder = (values: CreateOrderProps) => {
    const requestBody = {
      "case_id": values.case_id,
      "order_type": values.order_type,
      "po_number": values.po_number,
      "qty": values.qty
    }
    createOrder(requestBody)
  }

  useEffect(() => {
    if (creatOrderResponseData || createOrderError) {
      hideLoader();
      reset();
      hideModal();
      if(creatOrderResponseData){
        showToast([`Order Created Successfully`], ToastTypes.SUCCESS);
        refreshListing();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creatOrderResponseData, createOrderError]);
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <form onSubmit={handleSubmit(clickOnCreateOrder)}>
        <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title fs-3 text-primary" id="exampleModalLabel">
                Order Product
              </p>
              <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button>
            </div>

            <div className="modal-body">
              <p> Input information in the form below to place your order </p>

              <div className="row align-items-center mb-3">
                <div className="col-3">
                  <p className="mb-0 text-end"> Case *</p>
                </div>

                <div className="col-7">
                <Controller
                      name="case_id"
                      control={control}
                      defaultValue=""
                      render={({ field, fieldState: { error } }) => (
                        <HubInputField
                          inputId="case_id"
                          isRowBased={true}
                          isRequired={false}
                          field={field}
                          inputPlaceholder="Case ID *"
                          error={error}
                        />
                      )}
                    />
                </div>
              </div>

              <div className="row align-items-center mb-3">
                <div className="col-3">
                  <p className="mb-0 text-end"> Order Type * </p>
                </div>

                <div className="col-7">
                <Controller
                      name="order_type"
                      control={control}
                      defaultValue=""
                      render={({ field, fieldState: { error } }) => (
                        <HubInputField
                          inputId="order_type"
                          isRowBased={true}
                          isRequired={false}
                          field={field}
                          isDropdown={true}
                          isSearchable={false}
                          dropdownData={orderType.map(({ name,type }) => ({ label: name, value: type }) ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                          // inputPlaceholder="Order Type *"
                          error={error}
                        />
                      )}
                    />
                </div>
              </div>

              <div className="row align-items-center mb-3">
                <div className="col-3">
                  <p className="mb-0 text-end"> PO Number  </p>
                </div>

                <div className="col-7">
                <Controller
                      name="po_number"
                      control={control}
                      defaultValue=""
                      render={({ field, fieldState: { error } }) => (
                        <HubInputField
                          inputId="po_number"
                          isRequired={true}
                          isRowBased={true}
                          field={field}
                          error={error}
                          inputPlaceholder="PO Number"
                        />
                      )}
                    />
                </div>
              </div>

              <div className="row align-items-center">
                <div className="col-3">
                  <p className="mb-0 text-end"> Qty </p>
                </div>

                <div className="col-7">
                <Controller
                      name="qty"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <HubInputField
                          inputId="qty"
                          isRowBased={true}
                          isRequired={false}
                          field={field}
                          inputPlaceholder="Qty"
                          error={error}
                        />
                      )}
                    />
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-start ">
              <button type="submit" className="btn btn-primary" data-bs-dismiss="modal" >
                Order
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateOrderModal;
